// extracted by mini-css-extract-plugin
export default {"avatar":"Zlpy08Q","noPictureAvatar":"fa0EdFE"};